let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dpeU1")).then(() => parcelRequire('7NPrx'));